import React, { useState, useRef } from 'react';
import { useUI } from '../UIContext';

export default function CustomTagInput({
  tags,
  setTags,
  suggestions = [],
  style = {},
  inputStyle = {}
}) {
  const [input, setInput] = useState('');
  const [focused, setFocused] = useState(false);
  const { textStyle } = useUI();
  const inputRef = useRef(null);
  const lastAddTimeRef = useRef(0);

  const normalizeTag = (tag) => tag.trim().toLowerCase();

  const addTag = (rawInput) => {


    const existingNormalized = new Set(tags.map(normalizeTag));

    const newNormalized = new Set();
    rawInput
      .split(',')
      .map(normalizeTag)
      .forEach((tag) => {
        if (tag && !existingNormalized.has(tag)) {
          newNormalized.add(tag);
        }
      });

    if (newNormalized.size > 0) {
      setTags([...tags, ...Array.from(newNormalized)]);
    }

    setInput('');
  };

  const removeTag = (tag) => {
    setTags(tags.filter(t => normalizeTag(t) !== normalizeTag(tag)));
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      addTag(input);
    }
  };

  const parts = input.split(',');
  const lastTerm = parts[parts.length - 1].trim().toLowerCase();
  const priorTerms = parts.slice(0, -1).map(normalizeTag);
  const previewTags = [...priorTerms, lastTerm]
    .filter((t, i, arr) =>
      t.length > 0 &&
      arr.indexOf(t) === i && // remove duplicates within preview
      !tags.map(normalizeTag).includes(t)
    );

  const filteredSuggestions =
    lastTerm === ''
      ? suggestions.filter(s => !tags.map(normalizeTag).includes(normalizeTag(s)))
      : suggestions.filter(s =>
          s.toLowerCase().includes(lastTerm) &&
          !tags.map(normalizeTag).includes(normalizeTag(s))
        );

const handleSuggestionClick = (s) => {
  const currentParts = input.split(',');
  const trimmedLast = currentParts[currentParts.length - 1].trim();

  if (currentParts.length === 1 && trimmedLast.length === 0) {
    // Case 1: User clicked input but hasn't typed anything
    addTag(s);
  } else if (currentParts.length === 1 && trimmedLast.length > 0) {
    // Case 2: User is typing the first tag (e.g., "j") and clicks a suggestion
    addTag(s);
  } else {
    // Case 3: User already typed a comma (multi-tag input), continue filling
    currentParts[currentParts.length - 1] = ` ${s}`;
    setInput(currentParts.join(',').replace(/\s*,\s*$/, '') + ', ');
  }
};




  return (
    <div style={{ ...style, display: 'flex', flexDirection: 'column', gap: '4px' }}>
      {/* Selected tags */}
      <div style={{ display: 'flex', flexWrap: 'wrap', gap: '6px', marginBottom: '4px', marginTop: '4px', justifyContent: 'center' }}>
        {tags.map((tag, i) => (
          <span key={i} style={{
            ...textStyle,
            background: 'var(--input-bg)',
            color: 'var(--input-text, var(--text-primary))',
            padding: '4px 8px',
            borderRadius: '12px',
            display: 'inline-flex',
            alignItems: 'center',
            gap: '4px',
            fontSize: '0.75rem',
          }}>
            {tag}
            <button
              onClick={() => removeTag(tag)}
              style={{
                background: 'transparent',
                border: 'none',
                fontSize: '1rem',
                cursor: 'pointer',
                padding: 0,
                marginLeft: '4px',
                color: 'var(--input-text, var(--text-primary))',
              }}
            >
              ×
            </button>
          </span>
        ))}
      </div>

      {/* Input */}
      <div style={{ minWidth: '235px', maxWidth: '400px' }}>
        <input
          ref={inputRef}
          value={input}
          onChange={e => setInput(e.target.value)}
          onKeyDown={handleKeyDown}
          onFocus={() => setFocused(true)}
          onBlur={() => setTimeout(() => setFocused(false), 100)}
          placeholder="Add tags (click or comma-separated)"
          style={{ ...inputStyle, width: '100%' }}
        />
      </div>

      {/* Preview */}
      {previewTags.length > 0 && (
        <div style={{ fontSize: '0.75rem', color: 'gray', marginTop: '2px', justifyContent: 'center' }}>
          Enter to add: {previewTags.join(', ')}
         </div>
      )}

      {/* Suggestions */}
      {(focused || input.length > 0) && filteredSuggestions.length > 0 && (
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '6px', marginTop: '6px', justifyContent: 'center' }}>
          {filteredSuggestions.slice(0, 8).map((s, i) => (
            <div
              key={i}
onMouseDown={() => handleSuggestionClick(s)}
              style={{
                ...textStyle,
                cursor: 'pointer',
                background: 'var(--button-bg)',
                color: 'var(--button-text)',
                padding: '4px 10px',
                borderRadius: '12px',
                fontSize: '0.75rem',
                display: 'inline-block',
              }}
            >
              {s}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
